import ClipboardList from "./SVG/clipboard-list.svg?react";

const ClipboardListIcon = () => {
  return <ClipboardList />;
};

export default ClipboardListIcon;
